import { render, staticRenderFns } from "./commonmysubscribe.vue?vue&type=template&id=a63bdb6c&scoped=true"
import script from "./commonmysubscribe.vue?vue&type=script&lang=js"
export * from "./commonmysubscribe.vue?vue&type=script&lang=js"
import style0 from "./commonmysubscribe.vue?vue&type=style&index=0&id=a63bdb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63bdb6c",
  null
  
)

export default component.exports